// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f08ea062","703":"0e49d4f6","787":"175f9daa"}[chunkId] + ".chunk.js";
};